import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import classes from './MainLayout.module.css';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Button } from '../components/Button';
import { ChevronLeftIcon, ChevronRightIcon } from '../assets/icons';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { changePageDetails } from '../redux/appConfigSlice';
import { getButtonSize } from '../service/utils';
import { savePrecheckLogs } from '../api/authApis';

export const MainLayout = () => {
    const { appFontSize, pageObject, testTaker, selectedMic, appMicAccess, isSilent, precheckApiError, appTheme,
        speakCheckScreenDetails, fileSpeed, soundCheckScreenAudio, silenceMeanValue, insperaDetails } = useSelector((state: RootState) => state.appConfigSlice);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const isTestPage = location.pathname === '/test';

    function causeOfError() {
        let error = null;
        if (selectedMic?.label.trim() === '' && appMicAccess) {
            error = 'Microphone Notfound'
        } else if (isSilent) {
            error = 'Threshold not passed'
        } else if (precheckApiError) {
            error = precheckApiError
        }
        return error;
    }
    let errorMsg = causeOfError()
    let uniqueId = testTaker?.testTakerSessionId;
    let uniqueSessionId = uniqueId.replace(/[:.;]/g, "_");
    let fileName = `preCheckLog_${uniqueSessionId}.txt`;
    const payload = {
        testTakerId: testTaker?.testTakerId,
        uniqueSessionId: testTaker?.testTakerSessionId,
        centerName: testTaker?.testTakerCenterName,
        language: testTaker?.testTakerLanguage,
        status: "Prechecks completed",
        productType: insperaDetails?.product,
        fileName: fileName,
        preCheckLog: {
            fontSize: appFontSize,
            contrast: appTheme,
            speckerCheckScreenAudio: soundCheckScreenAudio ? 'played' : 'not-played',
            micCheck: selectedMic?.label,
            uploadSpeed: fileSpeed?.uploadSpeed,
            downloadSpeed: fileSpeed?.downloadSpeed,
            thresholdValue: silenceMeanValue,
            filePathOfRecording: speakCheckScreenDetails?.responseFilePath,
            duration: speakCheckScreenDetails?.duration,
            error: errorMsg
        }


    }


    const onClickNext = () => {
        if (pageObject.pageIndex < 4) {
            return dispatch(changePageDetails({ ...pageObject, pageIndex: pageObject.pageIndex + 1 }));
        }
        if (pageObject.isSpeakCheckDone) {
            let response = savePrecheckLogs(testTaker, payload)
        }
        
        return navigate('/test');
    };
    const onClickPrev = () => {
        dispatch(changePageDetails({ ...pageObject, pageIndex: pageObject.pageIndex - 1 }));
    };

    return (
        <div className={classes.container}>
            <Header sessionId={testTaker.testTakerSessionId} />
            <main className={classes.main}>
                <section
                    className={classes.content}
                    style={{ justifyContent: !testTaker.testTakerSessionId || isTestPage ? 'center' : undefined }}
                >
                    <Outlet />
                </section>
            </main>
            <Footer>
                {testTaker.testTakerSessionId && !isTestPage && (
                    <>
                        {pageObject.pageIndex !== 0 && (
                            <Button
                                data-test
                                className={classes.prevBtn}
                                disabled={pageObject.pageIndex === 4 && pageObject.disableSummaryScreenButton}
                                iconLeft={ChevronLeftIcon}
                                variant="secondary"
                                size={getButtonSize(appFontSize)}
                                onClick={onClickPrev}
                            >
                                Previous
                            </Button>
                        )}
                        <Button
                            className={classes.nextBtn}
                            iconRight={ChevronRightIcon}
                            disabled={
                                (pageObject.pageIndex === 3 && !pageObject.isSpeakCheckDone) ||
                                pageObject.disableSummaryScreenButton
                            }
                            size={getButtonSize(appFontSize)}
                            onClick={onClickNext}
                        >
                            Next
                        </Button>
                    </>
                )}
            </Footer>
        </div>
    );
};

MainLayout.displayName = 'MainLayout';
